let BASE_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:1338";
BASE_URL = BASE_URL.endsWith("/") ? BASE_URL.slice(0, -1) : BASE_URL;
const API_URL = `${BASE_URL}/api`;
export default API_URL;